import { Start } from './pages/start/start';

export const MAIN_PAGE = Start;
export const MAIN_PAGE_PATH = 'start';
